import {
    GIGAKOMBI_ERROR_CASE_WRAPPER,
    GIGAKOMBI_LANDINGPAGE_CONTAINER, LOADING_INDICATOR_IMAGE_CONTAINER,
    OFFER_EDITOR_INFORMATION_CONTAINER,
} from 'Constant';
import {maletsoScan} from 'Helper/matelsoHelper';

/**
 * gets errorDIV container or undefined
 */
const getErrorMessageDIV = (): HTMLElement => {
    const elErrorMessages = document.getElementsByClassName(OFFER_EDITOR_INFORMATION_CONTAINER);

    return elErrorMessages[0] as HTMLElement;

};

/**
 * Renders big, pink Errormessage for Editors
 * @param state
 */
const renderBigPinkError = (elErrorMessage, state) => {
    elErrorMessage.innerHTML = state.errorMessage;
    elErrorMessage.style.display = 'block';
};

/**
 * Hides the spinner image
 */
const hideLoadingSpinnerImage = () => {
    const loadingSpinnerWrapper = document.getElementsByClassName(LOADING_INDICATOR_IMAGE_CONTAINER);
    const loadingSpinnerImage = loadingSpinnerWrapper[0] as HTMLElement;
    loadingSpinnerImage.style.display = 'none';
};

/**
 * Hides the spinner image
 */
const showErrorCaseDIV = () => {
    const elErrorCase = document.getElementById(GIGAKOMBI_ERROR_CASE_WRAPPER);
    elErrorCase.style.display = 'block';
    try {
        // @TODO: kann raus, wenn nicht mehr Simplicity
        (window as any).vf['eq-height'].init();
    } catch (e) {}
};

/**
 * Hides the spinner image
 */
const hideGigakombiDIV = () => {
    const divGigakombi = document.getElementsByClassName(GIGAKOMBI_LANDINGPAGE_CONTAINER);
    const elGigakombi = divGigakombi[0] as HTMLElement;
    elGigakombi.style.display = 'none';
};

/**
 * ONLINE: Hides all Gigakombi stuff and displays static content instead
 * IN CMS PREVIEW: renders big pink overlay with Error message
 */
export const handleErrors = (state) => {
    // checks, if errorMessage DIV exists (it only exists in CMS preview)
    const errorDIV = getErrorMessageDIV();
    // we're in CMS preview, when DIV exists
    const cmsPreview: boolean = (undefined !== errorDIV);

    if (true === cmsPreview) {
        renderBigPinkError(errorDIV, state);
        hideLoadingSpinnerImage();
    } else {
        showErrorCaseDIV();
        hideGigakombiDIV();
        maletsoScan();
    }

};
